// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3-pIW","signatureBlock":"Footer_signatureBlock__Up4cn","signature":"Footer_signature__2tqpz"};